/**
 * @author Nelson
 */
export class Theme {
    static Primary = '#3F37C9';
}